import { defineStore } from 'pinia'
import { adminRoutes, merchantRoutes, constantRouterMap } from '@/router'
import {
  flatMultiLevelRoutes
} from '@/utils/routerHelper'
import { store } from '../index'
import { cloneDeep } from 'lodash-es'

export interface PermissionState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
  isAddRouters: boolean
  menuTabRouters: AppRouteRecordRaw[]
}

// 递归过滤路由
const filterRoutes = (routes: AppRouteRecordRaw[], permissions: string[]) => {
  const availableRoutes = routes.filter((route) => {
    if (permissions && route.meta.permission) {
      if (Array.isArray(route.meta.permission)) {
        return route.meta.permission.some((p) => permissions.includes(p))
      }
      return permissions.includes(route.meta.permission as string)
    }
    return true
  })
  return availableRoutes.map((route) => {
    const routeItem = { ...route }
    if (routeItem.children) {
      routeItem.children = filterRoutes(routeItem.children, permissions)
    }
    return routeItem
  })
}

export const usePermissionStore = defineStore('permission', {
  state: (): PermissionState => ({
    routers: [],
    addRouters: [],
    isAddRouters: false, // 标记是否已经添加动态路由
    menuTabRouters: []
  }),
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return flatMultiLevelRoutes(cloneDeep(this.addRouters))
    },
    getIsAddRouters(): boolean {
      return this.isAddRouters
    },
    getMenuTabRouters(): AppRouteRecordRaw[] {
      return this.menuTabRouters
    }
  },
  actions: {
    generateRoutes(
      type: 'admin' | 'merchant',
      permissions: string[]
    ): Promise<unknown> {
      return new Promise<void>((resolve) => {
        let routerMap: AppRouteRecordRaw[] = []
        if (type === 'admin') {
          routerMap = filterRoutes(adminRoutes, permissions)
        } else if (type === 'merchant') {
          routerMap = filterRoutes(merchantRoutes, permissions)
        } else {
          throw new Error('type is error')
        }

        // 动态路由，404一定要放到最后面
        this.addRouters = routerMap.concat([
          {
            path: '/:path(.*)*',
            redirect: '/404',
            name: '404Page',
            meta: {
              hidden: true,
              breadcrumb: false
            }
          }
        ])
        // 渲染菜单的所有路由
        this.routers = cloneDeep(constantRouterMap).concat(routerMap)
        resolve()
      })
    },
    setIsAddRouters(state: boolean): void {
      this.isAddRouters = state
    },
    setMenuTabRouters(routers: AppRouteRecordRaw[]): void {
      this.menuTabRouters = routers
    }
  },
  persist: {
    paths: ['routers', 'addRouters', 'menuTabRouters']
  }
})

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}
